export default {
  nav: {
    home: 'Home',
    features: 'Features',
    pricing: 'Pricing',
    faq: 'FAQ',
    translate: 'Manga Translation',
    startBtn: 'Start Translating',
    vip: 'VIP Channel',
    login: 'Login',
    logout: 'Logout',
    lang: 'EN',
  },
  landing: {
    title: 'KokeManga AI Manga Translation Tool',
    subtitle: 'AI-Powered · Batch Processing · Original Rendering',
    desc: 'Free online manga translation tool, supports JPG, PNG, WEBP formats',
    hero: {
      badge: 'AI-Powered Manga Translation',
      title: 'Smart Manga Translation',
      gradientText: 'One-Click Done',
      desc: 'Batch Upload · AI Recognition · Original Rendering · Multi-Language',
      startBtn: 'Start Translating',
      learnMore: 'Learn More',
      statsTranslated: 'Translations',
      statsFree: 'Free Quota',
      statsFreeNum: '20/Day',
      statsAccuracy: 'Accuracy',
    },
    comparison: {
      afterLabel: 'Translated',
      beforeLabel: 'Original',
    },
    advantage: {
      tag: 'Why Choose Us',
      title: 'Powerful Translation',
      desc: 'AI tool built specifically for manga translation, making translation simple and efficient',
      items: [
        {
          title: 'AI Translation',
          desc: 'Every image uses <span class="highlight">large model translation, no traditional machine translation</span>, intelligently recognizes text while preserving original layout',
        },
        {
          title: 'Original Rendering',
          desc: 'Intelligently recognizes manga style and background, blurs and restores translated text to blend perfectly with the original',
        },
        {
          title: 'Batch Processing',
          desc: 'Upload multiple manga images at once, translate entire chapters with one click, greatly improving efficiency',
        },
        {
          title: 'Multi-Language',
          desc: 'Supports Chinese, Traditional Chinese, and English translation, more languages coming soon',
        },
        {
          title: 'Privacy & Security',
          desc: 'Full data encryption, <span class="highlight">auto-delete within 24 hours</span> after translation, no upload or translation data retained',
        },
        {
          title: 'Multi-Format Export',
          desc: 'Download in JPG, PNG, WEBP and more formats to meet different platform needs',
        },
      ],
    },
    pricing: {
      tag: 'Credits',
      title: 'Flexible Pricing',
      desc: 'Get credits to unlock VIP channel for fast translation, large image translation and more VIP features. Credits never expire',
      unit: 'credits',
      note: 'Purchased credits never expire. VIP channel consumes credits per use based on image resolution.',
      packages: [
        { amount: '300 Credits', price: '¥6', desc: '≈240-300 manga pages' },
        { amount: '600 Credits', price: '¥12', desc: '≈480-600 manga pages' },
        { amount: '3000+1000 Credits', price: '¥60', desc: '≈3200-4000 manga pages', badge: '+33%' },
        { amount: '6000+3000 Credits', price: '¥120', desc: '≈7200-9000 manga pages', badge: '+50%' },
      ],
    },
    channelCompare: {
      title: 'Channel Comparison',
      free: {
        title: 'Public Queue (Free)',
        desc: "For users who don't mind waiting in queue",
        items: [
          'No login required',
          'Completely free, no credits consumed',
          'Lower queue priority',
          'Daily translation limit',
          'Large image not supported (max 2000×2000)',
        ],
      },
      vip: {
        title: 'VIP Channel (Credits Required)',
        desc: 'Fast translation, supports large images, credits consumed per use',
        items: [
          'Login required (all free features included)',
          'More translation settings',
          'Fast queue, priority translation',
          'No limit, credits consumed per use',
          'Large image supported (max 2000×20000)',
        ],
      },
    },
    faq: {
      tag: 'FAQ',
      title: 'FAQ',
      desc: 'Have other questions? Contact us',
      items: [
        {
          q: 'How many pages can the free public queue translate?',
          a: 'We support 20 free translations per day without login, with the same quality as VIP queue.',
        },
        { q: 'Why does translation take so long?', a: 'We use large model translation for quality, each image takes about 7-8 seconds on average.' },
        {
          q: 'Why do some images cost more credits?',
          a: 'Regular images cost 1 credit. Only long or ultra-high resolution images cost more. Our 2 credits convert to resolutions greater than 4K.',
        },
        {
          q: 'What if translation has issues?',
          a: 'We guarantee full support for any translation issues. Failed translations will have credits refunded to protect user rights.',
        },
        {
          q: "What's the difference between machine translation and large model translation?",
          a: 'Traditional machine translation relies on fixed rules and dictionaries, often producing stiff, out-of-context results. Large model translation uses deep learning to understand context, producing more natural and fluent translations, especially for manga dialogue, sound effects, and cultural references.',
        },
      ],
    },
    cta: {
      title: 'Ready to Start?',
      desc: 'Start using Koke Manga and experience smart manga translation',
      btn: 'Start Translating Now',
    },
    footer: {
      features: 'Features',
      pricing: 'Pricing',
      faq: 'FAQ',
      login: 'Login',
    },
    startBtn: 'Start Translating',
  },
    translate: {
    pageTitle: 'Smart Manga Translation Tool',
    pageDesc: 'Batch Upload · Auto Translation · Public Queue · Original Rendering',
    guideArrow: 'Click to Preview',
    uploadTitle: 'Batch Upload Manga',
    previewTitle: 'Manga Preview',
    historyTitle: 'Translation History',
    batchDownload: 'Batch Download',
    downloading: 'Downloading...',
    clearList: 'Clear List',
    previewDialog: 'Preview',
    confirm: 'OK',
    cancel: 'Cancel',
    systemPrompt: 'System Notice',
    reLogin: 'Re-login',
    httpError: 'HTTP Error',
    deleteConfirm: 'Are you sure to delete this file?',
    deleteTitle: 'Hint',
    deleteSuccess: 'Deleted successfully, backend cache cleared',
    deleteFailed: 'Delete failed',
    clearConfirm: 'Clear all file records and backend cache? This cannot be undone.',
    clearTitle: 'Warning',
    clearSuccess: 'All records cleared and backend cache cleared',
    clearFailed: 'Clear failed',
    selectFilesFirst: 'Please select files to download first',
    invalidFiles: '{count} selected files have no valid ID and cannot be downloaded',
    incompleteFiles: '{count} selected files are not yet translated and cannot be downloaded',
    downloadingWait: 'Downloading, please wait...',
    batchDownloadStart: 'Starting batch download of {count} files...',
    batchDownloadSuccess: 'Batch download successful',
    batchDownloadFailed: 'Batch download failed',
    downloadSuccess: 'Download successful',
    downloadFailed: 'Download failed',
    fileNotFound: 'File does not exist or has been deleted',
    serverError: 'Internal server error',
    networkError: 'Network error, please check connection and retry',
    noFileFound: 'No corresponding file found',
    fileIdMissing: 'File ID does not exist',
    fileNotComplete: 'Translation not yet complete, please wait',
    paramError: 'Invalid request parameters, please check selected files',
    privacy: 'Privacy Policy',
    agreement: 'Terms of Service',
    about: 'About Us',
    batchDownloadFilename: 'manga_translation_batch_download',
    uploadFirst: 'Please upload images first',
    uploadFailed: 'Upload failed',
    uploadNetworkError: 'Network error',
    uploadResult: 'Upload Result',
    uploadSuccess: 'Upload complete! {count} files succeeded',
    joinQueue: 'Join Translation Queue',
    imageCount: '{current}/{total} ({size})',
    imagePreview: 'Manga Preview',
  },
  manga: {
    navbar: {
      home: 'Home',
      freeQueue: 'Free Queue',
      vipQueue: 'VIP Queue',
      loggedIn: 'Logged In',
      currentTasks: 'Current Tasks',
      currentCredits: 'Current Credits',
      getCredits: 'Get Credits',
      myOrders: 'My Orders',
      myTranslations: 'My Translations',
      profile: 'Profile',
      feedback: 'Feedback',
      logout: 'Logout',
      user: 'User',
      taskCount: '{count}',
    },
    footer: {
      privacy: 'Privacy Policy',
      agreement: 'Terms of Service',
      about: 'About Us',
    },
    queueCard: {
      publicQueue: 'Public Translation Queue:',
      people: '',
      realtime: 'Real-time · Shared by all',
      speedQueue: 'Speed Queue:',
      speedDesc: 'First 100/day · Priority',
      vipQueue: 'VIP Queue:',
      vipDesc: 'Fast translation · VIP only',
    },
    upload: {
      dragHint: 'Click or drag images here',
      translating: 'Translating, please wait...',
      tip: 'Max {max} images, each under 10MB, total under 50MB',
      processing: 'Processing...',
      onlyImages: 'Only image files allowed!',
      sizeLimit: 'Image size cannot exceed 10MB!',
      totalSizeLimit: 'Total image size cannot exceed 50MB',
      maxFiles: 'Can only select {max} images',
      fileExists: 'File {name} already exists, skipped',
      added: 'Added {name}, total {count} images',
      removed: 'Removed {name}, {count} images remaining',
      waitTranslate: 'Currently translating, please wait for completion',
    },
    fileList: {
      empty: 'No translation records',
      selectAll: 'Select All ({selected}/{max})',
      timeJustNow: 'Just now',
      timeMinutesAgo: '{count} min ago',
      timeHoursAgo: '{count} hours ago',
      timeDaysAgo: '{count} days ago',
    },
    preview: {
      placeholder: 'Upload to preview manga',
      clearAll: 'Clear All',
      uploading: 'Uploading {progress}%',
      joinQueue: 'Join Translation Queue',
    },
    login: {
      welcomeBack: 'Welcome Back',
      createAccount: 'Create Account',
      loginSubtitle: 'Login to use VIP translation channel',
      registerSubtitle: 'Register to experience VIP translation service',
      email: 'Email address',
      password: 'Password',
      confirmPassword: 'Confirm password',
      loginBtn: 'L O G I N',
      registerBtn: 'S I G N  U P',
      noAccount: "Don't have an account? Click to register",
      hasAccount: 'Already have an account? Click to login',
      forgotPassword: 'Forgot password?',
      loginAgreement: 'By logging in, you agree to',
      registerAgreement: 'By registering, you agree to',
      and: 'and',
      privacyPolicy: 'Privacy Policy',
      channelCompare: 'Channel Comparison',
      channelDesc: 'Learn the difference between free and VIP channels',
      freeQueue: 'Public Queue (Free)',
      freeQueueDesc: "For users who don't mind waiting in queue",
      freeItems: ['No login required', 'Completely free, no credits consumed', 'Lower queue priority', 'Daily translation limit', 'Large image not supported (max 2000×2000)'],
      vipQueue: 'VIP Channel (Credits Required)',
      vipQueueDesc: 'Fast translation, supports large images, credits consumed per use',
      vipItems: ['Login required (all free features included)', 'More translation settings', 'Fast queue, priority translation', 'No limit, credits consumed per use', 'Large image supported (max 2000×20000)'],
      usageTipTitle: 'Usage Tips',
      usageTipDesc: 'Free users can use the public queue. For fast translation or large images, use VIP channel. Purchased credits never expire.',
      emailRequired: 'Please enter email address',
      emailInvalid: 'Please enter a valid email address',
      passwordRequired: 'Please enter password',
      passwordMin: 'Password must be at least 6 characters',
      confirmRequired: 'Please confirm password',
      confirmMismatch: 'Passwords do not match',
      agreementTitle: 'Terms of Service',
      privacyTitle: 'Privacy Policy',
      loginSuccess: 'Login successful',
      registerSuccess: 'Registration successful, please login',
      loginFailed: 'Login failed, please check email and password',
      registerFailed: 'Registration failed, please try again later',
    },
    vip: {
      pageTitle: 'VIP Translation Channel',
      pageDesc: 'VIP Exclusive · Priority Processing · Dedicated Queue · Unlimited',
      uploadTitle: 'VIP Upload',
      previewTitle: 'VIP Preview',
      historyTitle: 'VIP Translation History',
      maxImages: 'Max 50 images',
      eachLimit: 'Each under 10MB',
      totalLimit: 'Total under 50MB',
      batchMax: 'Max 50 batch download',
      clearHistory: 'Clearing...',
      clear: 'Clear',
      searchPlaceholder: 'Enter file name',
      statusLabel: 'Translation Status',
      waiting: 'Waiting',
      translating: 'Translating',
      failed: 'Failed',
      completed: 'Completed',
      query: 'Search',
      reset: 'Reset',
      fileName: 'Manga Name',
      translateStatus: 'Status',
      currentQueue: 'Queue',
      creditsCost: 'Credits Cost',
      targetLanguage: 'Target Language',
      action: 'Action',
      noRecords: 'No translation records',
      refresh: 'Refresh',
      configTitle: 'Translation Config',
      configLangLabel: 'Target Language',
      configLangPlaceholder: 'Select target language',
      configLayoutLabel: 'Layout Mode',
      configLayoutPlaceholder: 'Select layout mode',
      configConfirm: 'Confirm',
      statusWaiting: 'Waiting',
      statusTranslating: 'Translating',
      statusFailed: 'Failed',
      statusCompleted: 'Completed',
      statusExpired: 'Expired',
      statusUnknown: 'Unknown',
      defaultLang: 'Simplified Chinese',
      fileNotFound: 'File does not exist or has been deleted',
      serverError: 'Internal server error, download failed',
      networkError: 'Network error, please check connection and retry',
      noFileFound: 'No corresponding file found',
      fileNotComplete: 'Translation not yet complete, please wait',
      fileIdMissing: 'File ID does not exist, cannot preview',
      selectFilesFirst: 'Please select files to download first',
      downloadingWait: 'Downloading, please wait...',
      incompleteFiles: '{count} selected files are not yet translated and cannot be downloaded',
      batchDownloadStart: 'Starting VIP batch download of {count} files...',
      paramError: 'Invalid request parameters, please check selected files',
      deleteConfirm: 'Are you sure to delete this record?',
      deleteTitle: 'Hint',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Delete failed',
      clearConfirm: 'Are you sure to clear all completed and failed records? This cannot be undone.',
      clearSuccess: 'Cleared successfully',
      clearFailed: 'Clear failed',
    },
    getPower: {
      title: 'Get Translation Credits',
      subtitle: 'Get credits to unlock VIP channel for fast translation, large image translation and more VIP features. VIP features have no limits, credits consumed per use.',
      contactAdmin: 'Contact Admin',
      currentBalance: 'Current Balance',
      creditsUnit: 'credits',
      packageTitle: 'Credit Packages',
      packageDesc: 'Choose a package below to buy credits. Credits can be used for VIP channel and never expire.',
      noPackage: 'No packages available',
      payMethod: 'Payment Method',
      alipay: 'Alipay',
      wechatPay: 'WeChat Pay',
      selectPackage: 'Please select a package',
      buyButton: 'Buy Now',
      privacyTitle: 'Privacy Protection',
      privacyDesc: 'To protect user privacy, we do not store any translated images. All translation data is automatically cleared within 24 hours after completion. Please download promptly.',
      channelCompare: 'Channel Comparison',
      channelDesc: 'Learn the difference between free and VIP channels. VIP channel consumes credits.',
      usageTipTitle: 'Usage Tips',
      usageTipDesc: 'Free users can use the public queue. For fast translation or large images, use VIP channel. Purchased credits never expire.',
      calcTitle: 'Credit Calculation',
      calcDesc: 'Regular images cost 1 credit. Long/ultra-high resolution images cost more. 2 credits correspond to resolutions greater than 4K.',
      payPending: 'Waiting for payment',
      paySuccess: 'Payment successful!',
      payFailed: 'Payment failed',
      createOrderFailed: 'Failed to create payment order',
      pleaseSelectPackage: 'Please select a package first',
      qrcodeTitle: 'Scan to Pay',
      qrcodeDesc: 'Please use {method} to scan and pay',
      payConfirming: 'Confirming payment...',
      payTimeout: 'Payment timeout, please retry',
    },
    order: {
      loading: 'Loading...',
      typeGift: 'Gift',
      typeAlipay: 'Alipay',
      typeWechat: 'WeChat',
      typeBilibili: 'Bilibili',
      typePaypal: 'PayPal',
      payProcessing: 'Processing payment...',
      backHome: 'Back to Home',
      statePending: 'Pending',
      stateSuccess: 'Paid',
      stateFailed: 'Failed',
      stateConfirming: 'Confirming',
      stateClosed: 'Closed',
      unknown: 'Unknown',
    },
    userMessage: {
      pending: 'Pending',
      replied: 'Replied',
      placeholder: 'Enter your message...',
      submitting: 'Submitting...',
      submit: 'Submit',
      messageContent: 'Message Content',
      suggestionContent: 'Suggestion Content',
      message: 'Message',
      suggestion: 'Suggestion',
    },
    userProfile: {
      nicknamePlaceholder: 'Enter nickname',
      phoneBound: 'Bound: {phone}',
      phoneUnbound: 'Phone not bound',
      emailBound: 'Bound: {email}',
      emailUnbound: 'Email not bound',
      wechatBound: 'WeChat authorized',
      wechatUnbound: 'WeChat not bound',
      change: 'Change',
      bind: 'Bind',
      unbind: 'Unbind',
      selectImageError: 'Please select an image file',
      imageSizeError: 'Image size cannot exceed 5MB',
      avatarSuccess: 'Avatar uploaded successfully',
      avatarFailed: 'Upload failed',
      avatarRetry: 'Upload failed, please retry',
      saveSuccess: 'Profile saved successfully',
      saveFailed: 'Save failed',
      saveRetry: 'Save failed, please retry',
    },
    resetPassword: {
      title: 'Reset Password',
      step1: 'Verify Email',
      step2: 'Enter Code',
      step3: 'Set New Password',
      emailPlaceholder: 'Enter registered email',
      sendCode: 'Send Code',
      codePlaceholder: 'Enter verification code',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      resetBtn: 'Reset Password',
      backToLogin: 'Back to Login',
      stepDesc1: 'Enter the email you used to register',
      stepDesc2: 'Enter the 6-digit verification code you received',
      stepDesc3: 'Set your new password',
      codeSentTo: 'Code sent to:',
      resendAfter: 'Resend in {countdown}s',
      resendCode: 'Resend verification code',
      verifyBtn: 'Verify',
      codeRequired: 'Please enter verification code',
      codeLen: 'Verification code must be 6 digits',
      emailRequired: 'Please enter email address',
      emailInvalid: 'Please enter a valid email address',
      passwordRequired: 'Please enter password',
      passwordMin: 'Password must be at least 6 characters',
      confirmRequired: 'Please confirm password',
      confirmMismatch: 'Passwords do not match',
      codeSentSuccess: 'Verification code sent, please check your email',
      verifySuccess: 'Verified successfully, please set new password',
      resetSuccess: 'Password reset successfully, please login again',
    },
    seo: {
      landing: {
        title: 'KokeManga AI Manga Translation Tool - AI-Powered · Batch Processing',
        description: 'KokeManga is a free online manga translation tool, supports JPG, PNG, WEBP formats, AI translation and batch processing.',
      },
      translate: {
        title: 'KokeManga Manga Translation - Online Translation Tool',
        description: 'Online manga translation tool, supports batch upload, auto translation, original rendering',
      },
      vip: {
        title: 'KokeManga VIP Translation Channel',
        description: 'VIP exclusive manga translation channel, priority processing, dedicated queue',
      },
    },
    privacy: {
      intro: 'Welcome to our online manga translation tool. We take your privacy and data security very seriously. This Privacy Policy explains clearly how we collect, use, store, and process your information, especially the manga images you upload.',
      s1Title: '1. Information Collection',
      s1Content: 'We only collect and access the manga image files you actively choose and upload while using this tool. Apart from this, we do not actively collect, store, or request any other personally identifiable information (such as name, email, IP address, device information, etc.).',
      s2Title: '2. How We Use Information',
      s2Content: 'Your uploaded manga images are used solely to provide the instant translation service you requested. Core image processing, text recognition, and translation computation are performed locally in your browser or device. We promise:',
      s2Item1: 'Local Processing: Uploaded image files are not automatically, proactively, or routinely transmitted to our servers or any third-party servers for processing.',
      s2Item2: 'Purpose Limitation: Image content is only used to generate translation results and will not be used for any other purpose, including but not limited to machine learning model training, content analysis, marketing, or any form of redistribution.',
      s3Title: '3. Information Storage & Retention',
      s3Content: 'We understand the importance of temporary file security. Our data storage principles are as follows:',
      s3Item1: 'Auto-Deletion: All original image files you upload and generated translation results will be permanently and irreversibly deleted from our systems within 24 hours after processing is complete.',
      s3Item2: 'No Long-Term Archives: We do not establish or retain any long-term databases, archives, or backups related to your uploaded content.',
      s4Title: '4. Your Rights',
      s4Content: 'As the data provider, you have the following rights:',
      s4Item1: 'Control: You have full control over your uploaded content. You can close the browser tab at any time after use.',
      s4Item2: 'Right to Know: You have the right to understand how we process your files through this policy.',
      s5Title: '5. Third-Party Services',
      s5Content: 'The current service does not involve embedding third-party analytics, advertising, or tracking tools. If any trusted third-party services are introduced in the future to improve functionality, we will clearly state this in this policy and ensure they meet equally strict privacy standards.',
      s6Title: '6. Changes to Privacy Policy',
      s6Content: 'We may update this Privacy Policy from time to time. If there are significant changes, we will post a prominent notice on the tool interface. Your continued use of our service constitutes acceptance of the updated policy.',
      s7Title: '7. Contact Us',
      s7Content: 'If you have any questions, comments, or concerns about this Privacy Policy or our data handling practices, please contact us at: Koke7359@163.com',
      s8Title: '8. Applicable Law',
      s8Content: 'The formation, execution, and interpretation of this Privacy Policy are governed by the laws of the People\'s Republic of China.',
    },
    agreement: {
      updateDate: 'Last Updated: April 2, 2026',
      intro: 'Welcome to this online manga translation tool (hereinafter referred to as "this tool" or "this service"). Please carefully read and understand the full content of this User Agreement (hereinafter referred to as "this Agreement") before use. If you do not agree to any terms of this Agreement, please stop using this tool immediately. Your upload, access, or use of this tool constitutes your having read, understood, and agreed to be fully bound by this Agreement and our Privacy Policy.',
      s1Title: '1. Service Description',
      s1Content: 'This tool provides a free online technical translation service: you upload manga images containing text, and we generate translation results through technical means (such as image recognition and machine translation). You understand and agree that translation results are automatically generated by algorithms, are for assisting understanding only, and no express or implied guarantee is made regarding their accuracy, completeness, or applicability.',
      s2Title: '2. User Code of Conduct',
      s2Content: 'You commit to complying with all applicable laws and regulations, and independently bear all responsibilities arising from your use of this service. When using this service, you shall not engage in the following behaviors:',
      s2Subtitle1: 'Uploading, transmitting, sharing, or storing any manga images containing or related to the following content:',
      s2Item1: 'Infringing Content: Content that infringes upon others\' intellectual property rights (such as copyright, trademark rights), portrait rights, privacy rights, or other legitimate rights and interests.',
      s2Item2: 'Illegal & Non-compliant Content: Content that violates any laws, regulations, rules, or ordinances, or contains any illegal, fraudulent, defamatory, harassing, or intimidating information.',
      s2Item3: 'Harmful & Undesirable Content: Content containing pornography, obscenity, violence, gore, hate speech, or promoting discrimination based on race, gender, religion, disability, sexual orientation, etc.',
      s2Item4: 'Sensitive Content: Content involving state secrets, national security, public safety, political sensitivity, or content unsuitable for minors.',
      s2Subtitle2: 'Other Prohibited Behaviors:',
      s2Item5: 'Using this tool for any commercial purpose, illegal purpose, or engaging in any behavior that interferes with or disrupts the normal operation of the service (such as attempting to入侵 the system, uploading malicious software, etc.).',
      s2Item6: 'Impersonating any individual or entity, or making false representations about your affiliation with any individual or entity.',
      s3Title: '3. Responsibility for User Uploaded Content',
      s3Content1: 'You shall bear full legal responsibility for all manga image content you upload (hereinafter referred to as "user content"). You guarantee that you possess all necessary legal rights or have obtained sufficient authorization to upload such content, and that the use of such content does not violate any law or infringe upon any third party\'s rights.',
      s3Content2: 'Once your uploaded content violates this Agreement, the relevant legal responsibility shall be borne by you. If this causes losses to us or any third party, you shall be responsible for full compensation.',
      s4Title: '4. Intellectual Property',
      s4Content1: 'Your Rights: You retain all intellectual property rights and related rights to the original manga images you upload. The act of uploading itself does not mean you transfer any rights to us.',
      s4Content2: 'Our Rights: All intellectual property rights and related rights contained in this tool and its services (including but not limited to software, interface, logo, technology) belong to us and/or our licensors. Without our explicit written permission, you may not copy, modify, reverse engineer, or commercially use them in any form.',
      s5Title: '5. Service Changes, Interruptions & Termination',
      s5Content1: 'We reserve the right to modify, suspend, or interrupt this service (or any part thereof) at any time without prior notice to you and without any liability to you or any third party.',
      s5Content2: 'If we have reasonable grounds to believe that you have violated any provision of this Agreement, we have the right to unilaterally and immediately suspend or terminate the provision of services to you and delete related user content without bearing any responsibility.',
      s6Title: '6. Disclaimer',
      s6Content: 'To the maximum extent permitted by applicable law, this service is provided "as is" and "as available" without any form of express or implied warranty. You understand and agree:',
      s6Item1: 'We do not guarantee that the service will be uninterrupted, timely, secure, or error-free.',
      s6Item2: 'We do not guarantee the accuracy, reliability, or applicability of translation results. Translation results are for reference only and do not constitute professional translation advice. You should judge their value and be responsible for the results of use.',
      s6Item3: 'We shall not be liable for any direct, indirect, incidental, punitive, or consequential losses (including but not limited to data loss, profit loss, goodwill loss) arising from your uploaded content, whether or not we have been advised of the possibility of such damages.',
      s7Title: '7. Data Retention',
      s7Content: 'You acknowledge and agree that we temporarily process your uploaded images and generated translation results in accordance with the Privacy Policy. All data will be automatically cleared within 24 hours after processing is complete. You are responsible for backing up any content you wish to retain.',
      s8Title: '8. Modifications to Agreement',
      s8Content: 'We reserve the right to update or modify this Agreement at any time. The updated Agreement will be published on this page and the "Last Updated" date will be updated. Your continued use of this service constitutes acceptance of the updated Agreement. We recommend that you periodically review this page for the latest terms.',
      s9Title: '9. Other Provisions',
      s9Item1: 'Severability: If any provision of this Agreement is found to be invalid or unenforceable, such provision shall be limited or excluded to the minimum extent necessary, and the validity of other provisions shall not be affected.',
      s9Item2: 'Entire Agreement: This Agreement, together with our Privacy Policy, constitutes the entire agreement between you and us regarding this service and supersedes any prior oral or written agreements.',
    },
    about: {
      title: 'Welcome to Koke',
      intro: 'We started from a simple belief: language should not be a barrier to exploring the wonderful world of manga.',
      missionTitle: 'Our Mission',
      missionContent: 'Koke is dedicated to building a truly efficient, simple, and free intelligent translation tool, enabling every manga enthusiast to enjoy reading without barriers. We believe technology should serve people, removing obstacles in the most seamless way, letting wonderful stories and art reach hearts directly.',
      coreTitle: 'Our Core: Your Privacy & Convenience',
      toolTitle: 'A Pure Tool',
      toolContent: 'Koke is a focused tool. You upload, we translate, that\'s it. We don\'t build communities, store content, or track users.',
      privacyTitle: 'Privacy First',
      privacyContent: 'Your data serves only you. To maximize your privacy protection, the image processing and recognition required for translation are completed locally in your browser. We do not transmit your original images to the server. All related data is automatically and completely cleared after 24 hours. We retain no copies. This is our promise to your trust.',
      efficientTitle: 'Simple & Efficient',
      efficientContent: 'We摒弃 all unnecessary features and complex interfaces, focusing on improving the overall speed and experience from upload to translation result, making translation as natural as turning a page.',
      futureTitle: 'Looking Forward',
      futureContent: 'We will continue to optimize translation accuracy and handling of complex layouts, strictly adhering to our original aspiration of "efficient, simple, free, and secure." We hope Koke becomes the lightweight yet reliable key in your hand as you explore the manga universe.',
      thankYou: 'Thank you for using our service.',
      signature: 'The Koke Team',
    },
  },
}
